export default __webpack_public_path__ + "static/media/Background_00205.83c9d928.png";